import { render, staticRenderFns } from "./seaBookingSpecialGoods.vue?vue&type=template&id=68db642c&scoped=true&"
import script from "./seaBookingSpecialGoods.vue?vue&type=script&lang=js&"
export * from "./seaBookingSpecialGoods.vue?vue&type=script&lang=js&"
import style0 from "./seaBookingSpecialGoods.vue?vue&type=style&index=0&id=68db642c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68db642c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68db642c')) {
      api.createRecord('68db642c', component.options)
    } else {
      api.reload('68db642c', component.options)
    }
    module.hot.accept("./seaBookingSpecialGoods.vue?vue&type=template&id=68db642c&scoped=true&", function () {
      api.rerender('68db642c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingSpecialGoods.vue"
export default component.exports